/**
 * auth-signup.js - 회원가입 페이지 전용 스크립트
 */

// 이메일 인증 요청
function requestEmailVerification() {
  const emailInput = document.getElementById('email');
  const email = emailInput.value.trim();

  if (!email) {
    alert('이메일을 입력해주세요.');
    emailInput.focus();
    return;
  }

  // 이메일 형식 검증
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!emailRegex.test(email)) {
    alert('올바른 이메일 형식을 입력해주세요.');
    emailInput.focus();
    return;
  }

  // 인증 모달 열기
  const modal = document.getElementById('emailVerificationModal');
  modal.style.display = 'block';
  document.body.style.overflow = 'hidden';

  // 인증번호 입력창 초기화 및 포커스
  const codeInput = document.getElementById('verificationCode');
  codeInput.value = '';
  setTimeout(() => codeInput.focus(), 100);
}

// 인증 확인
function confirmVerification() {
  const codeInput = document.getElementById('verificationCode');
  const code = codeInput.value.trim();

  if (!code) {
    alert('인증번호를 입력해주세요.');
    codeInput.focus();
    return;
  }

  // 더미 인증 - 아무 텍스트나 숫자를 입력하면 인증 완료
  // 실제로는 서버에서 발송한 인증번호와 비교해야 함
  
  // 인증 완료 처리
  const verifyBtn = document.getElementById('emailVerifyBtn');
  verifyBtn.textContent = '인증완료';
  verifyBtn.classList.add('verified');
  verifyBtn.disabled = true;
  verifyBtn.onclick = null;

  // 이메일 입력란 비활성화
  const emailInput = document.getElementById('email');
  emailInput.readOnly = true;
  emailInput.style.backgroundColor = '#f0f0f0';

  // 모달 닫기
  closeVerificationModal();

  alert('이메일 인증이 완료되었습니다.');
}

// 인증 모달 닫기
function closeVerificationModal() {
  const modal = document.getElementById('emailVerificationModal');
  modal.style.display = 'none';
  document.body.style.overflow = 'auto';
}

// 페이지 로드 시 이벤트 리스너 등록
document.addEventListener('DOMContentLoaded', function() {
  // 모달 외부 클릭 시 닫기
  const modal = document.getElementById('emailVerificationModal');
  if (!modal) {
    return; // 회원가입 페이지가 아니면 종료
  }
  if (modal) {
    window.addEventListener('click', function(event) {
      if (event.target === modal) {
        closeVerificationModal();
      }
    });
  }

  // ESC 키로 모달 닫기
  document.addEventListener('keydown', function(event) {
    if (event.key === 'Escape') {
      const modal = document.getElementById('emailVerificationModal');
      if (modal && modal.style.display === 'block') {
        closeVerificationModal();
      }
    }
  });

  // Enter 키로 인증 확인
  const codeInput = document.getElementById('verificationCode');
  if (codeInput) {
    codeInput.addEventListener('keypress', function(event) {
      if (event.key === 'Enter') {
        confirmVerification();
      }
    });
  }
});
